<template>
  <p-search-screen
    title="Sequences"
    api-destination="sequences"
    edit-key="id"
    :filters="filters"
    :fields="fields"
    :filterBy="filterBy"
  >
  </p-search-screen>
</template>

<script>
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';

export default {
  mixins: [SearchStorage],
  data() {
    return {
      filterName: 'SequencesFilter',
      filters: {
        automatic: "",
        perPage: 100,
        sortBy: 'name',
        sortDesc: true,
        searchBy:'All'
      },
      filterBy:[
          'All',
          'Sequence Name',
          'Template Name',
          'Type'
      ],
      fields: [
        {
          key: "name",
          sortable: true
        },
        {
          key: "locationName",
          label: "Location",
          sortable: true
        },
        {
          key: "template",
          sortable: true
        },
        {
          key: "sequenceTypeName",
          label: "Type",
          sortable: true
        },
        {
          key: "first",
          thClass: "text-center",
          tdClass: "text-end",
          sortable: true
        },
        {
          key: "next",
          thClass: "text-center",
          tdClass: "text-end",
          sortable: true
        },
        {
          key: "last",
          thClass: "text-center",
          tdClass: "text-end",
          sortable: true
        }
      ]
    };
  }
};
</script>